import { styled } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';
import { Typography } from '@components/Typography';
import { useTranslation } from '@hooks';

const Container = styled('div')({
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

const Progress = styled(CircularProgress)({
    color: 'var(--text-tertiary)',
    width: '58px !important',
    height: '58px !important',
    display: 'block',
    margin: '0 auto 24px',
});

const ReviewsAreLoading = () => {
    const { t } = useTranslation();
    return (
        <Container>
            <div>
                <Progress />
                <Typography
                    variant="h4"
                    sx={{ color: 'var(--primary-main)', marginBottom: '8px', textAlign: 'center' }}
                >
                    {t('ReviewsEmptyFeed.reviewsAreLoadingTitle')}
                </Typography>
                <Typography variant="body2" sx={{ color: 'var(--text-secondary)', textAlign: 'center' }}>
                    {t('ReviewsEmptyFeed.reviewsAreLoadingDescription')}
                </Typography>
            </div>
        </Container>
    );
};

export default ReviewsAreLoading;
